// extracted by mini-css-extract-plugin
export default {"btn":"mainButton_btn__GRD2p","defaultBtn":"mainButton_defaultBtn__o9i4a"};